import { all, call, put, select, take, takeLatest } from "redux-saga/effects";
import LogRocket from 'logrocket';
import { push } from "connected-react-router";
import * as authService from "../../services/auth.service";
import * as profileService from "../../services/profile.service";
import * as actions from "../actions/auth.actions";
import { addContactAction } from "../actions/contacts.actions";
import { loadProfileAction, LOAD_PROFILE, RESET_PROFILE_STATE } from "../actions/profile.actions";
import { toaster } from "../../components/Toasts/toaster";
import { cookies } from "../../utils/storage/CookieItem";

export function* loginSaga(action) {
  try {
    const { username, password, facebook, accessToken } = action.payload;
    let result = null;
    yield put({ type: `${actions.LOGIN}_PENDING` });

    if (facebook && accessToken) {
      result = yield call(authService.faceBookLoginRequest, accessToken);
    } else {
      result = yield call(authService.loginRequest, username, password);
    }

    if (result.data.errors) {
      yield put({
        type: `${actions.LOGIN}_FAILED`,
        payload: result.data.errors
      });
    } else {
      yield put({ type: RESET_PROFILE_STATE });
      yield authService.setToken(result.data.token);
      yield authService.setUserId(result.data.user_id);
      yield profileService.setProfileId(result.data.profile_id);
      yield put(loadProfileAction());
      yield put({ type: `${actions.LOGIN}_SUCCEEDED`, payload: result });
      yield take(`${LOAD_PROFILE}_SUCCEEDED`);

      const profile = yield select(state => state.profile);

      yield LogRocket.identify(profile.profile.user, {
        name: profile.profile.first_name + '' + profile.profile.last_name,
        email: profile.profile.email,
        ...profile.profile,
      });

      if (!profile.hasValidatedPhoneNumber) {
        yield put(push("/confirm-number"));
      } else if (!profile.hasRequiredProfileData) {
        yield put(push("/required-profile"));
      } else {
        const contact = cookies.get("contact-pre-join")
        if (contact) {
          const contactURL = "/contact-card/" + contact;
          yield put(push(contactURL));
        } else {
          yield put(push("/"));
        }
        // Change 
        // Otherwise route to dashboard
        yield put(push("/"));
      }
    }
  } catch (error) {
    yield put({ type: `${actions.LOGIN}_FAILED`, payload: error });
  }
}

export function* logoutSaga() {
  try {
    yield put({ type: RESET_PROFILE_STATE });
    yield put({ type: `${actions.LOGOUT}_PENDING` });
    yield profileService.clearProfileId();
    yield authService.clearToken();
    yield authService.clearUserId();
    yield put({ type: `${actions.LOGOUT}_SUCCEEDED` });
    yield put(push("/logout"));
  } catch (error) {
    yield put({ type: `${actions.LOGOUT}_FAILED` });
  }
}

export function* deleteUserSaga() {
  try {
    yield put({ type: `${actions.DELETE_USER}_PENDING` });
    yield authService.deleteAccountRequest();
    yield authService.clearToken();
    yield authService.clearUserId();
    yield put({ type: `${actions.DELETE_USER}_SUCCEEDED` });
    yield put(push("/logout"));
    yield call(toaster, "accountDeleted");
  } catch (error) {
    yield put({ type: `${actions.DELETE_USER}_FAILED` });
  }
}

export function* changePasswordSaga(action) {
  try {
    yield put({ type: `${actions.CHANGE_PASSWORD}_PENDING` });
    const user_id = yield authService.getUserId();

    const result = yield call(
      authService.changePasswordRequest,
      {
        user_id,
        ...action.payload,
      }
    );
    yield put({
      type: `${actions.CHANGE_PASSWORD}_SUCCEEDED`,
      payload: result
    });
    yield put(push("/"));
  } catch (error) {
    console.log(error);
    yield put({ type: `${actions.CHANGE_PASSWORD}_FAILED`, payload: error });
  }
}

export function* registerSaga(action) {
  try {
    const { username, password } = action.payload;
    yield put({ type: `${actions.REGISTER}_PENDING` });
    const result = yield call(authService.registerRequest, username, password);
    yield put({ type: `${actions.REGISTER}_SUCCEEDED`, payload: result });
    yield put({ type: actions.LOGIN, payload: { username, password } });
    // yield put(push('/'));
  } catch (error) {
    console.log(error);
    yield put({ type: `${actions.LOGIN}_FAILED`, payload: error });
  }
}

export function* validateTokenSaga() {
  try {
    yield put({ type: `${actions.VALIDATE_TOKEN}_PENDING` });
    const token = yield authService.getToken();
    const user_id = yield authService.getUserId();
    yield authService.validateToken(token, user_id);
    yield put({ type: `${actions.VALIDATE_TOKEN}_SUCCEEDED` });
    yield put(loadProfileAction());
  } catch (error) {
    yield put({ type: `${actions.VALIDATE_TOKEN}_FAILED` });
    yield put({ type: actions.LOGOUT });
  }
}

export function* watchDeleteUserSaga() {
  yield takeLatest(actions.DELETE_USER, deleteUserSaga);
}

export function* watchLoginSaga() {
  yield takeLatest(actions.LOGIN, loginSaga);
}

export function* watchLogoutSaga() {
  yield takeLatest(actions.LOGOUT, logoutSaga);
}

export function* watchChangePasswordSaga() {
  yield takeLatest(actions.CHANGE_PASSWORD, changePasswordSaga);
}

export function* watchRegisterSaga() {
  yield takeLatest(actions.REGISTER, registerSaga);
}

export function* watchValidateTokenSaga() {
  yield takeLatest(actions.VALIDATE_TOKEN, validateTokenSaga);
}

export default function* authSagas() {
  yield all([
    watchDeleteUserSaga(),
    watchLoginSaga(),
    watchLogoutSaga(),
    watchRegisterSaga(),
    watchValidateTokenSaga(),
    watchChangePasswordSaga()
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/auth.sagas.js